module.exports = __webpack_public_path__ + "static/media/Tq2.40acd812.jpg";